import {Component, OnInit, ViewChild} from '@angular/core';
import * as moment from 'moment';
import {ApiFactoryService} from '../../../shared/services/api-factory.service';
import {AbstractBffApi, AosOrderInterface, SelectEntityOption} from '../../../models/sharedinterface';
import {Router} from '@angular/router';
import {ShareddataService} from '../../../shared/services/shareddata.service';
import {GlobalsService} from '../../../shared/services/globals.service';
import {I18nService} from '../../../shared/services/i18n.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '../../../security/authentication.service';

@Component({
  selector: 'app-aos-orders',
  templateUrl: './aos-orders.component.html',
  styleUrls: ['./aos-orders.component.scss']
})

export class AosOrdersComponent implements OnInit {

  serverRoot: string;

  bffapi: AbstractBffApi;

  // Users
  public users: SelectEntityOption[];

  // Countries
  public markets: SelectEntityOption[];

  // Companies
  public companies: SelectEntityOption[];

  // Product types
  public productTypes: SelectEntityOption[];

  // max date
  public today: Date = new Date();

  public showFilters: boolean;

  // filter options
  public filterOptions = {
    maxDisplayedOrder: 100,
    defaultDateInterval: 3
  };

  public filterObject: {
    filtervalue: string;
    productTypeId: number;
    fromDate: Date;
    untilDate: Date;
    marketId: number;
    companyId: number;
    userId: number;
  } = {
    filtervalue: '',
    productTypeId: 0,
    fromDate: moment().subtract(this.filterOptions.defaultDateInterval, 'months').toDate(), // default range = 3 months
    untilDate: new Date(),
    marketId: 0,
    companyId: 0,
    userId: 0
  };

  // oldest records fetched
  private oldestDate: Date;

  // current order
  public currentOrder: AosOrderInterface;

  // show search
  public showSearch: boolean;

  // export options
  public exportOptions = {
    fileName: this.i18n.get('orders_aos_orders_export_filename', 'orders'),
    sheet: this.i18n.get('orders_export_sheetname', 'orders')
  };

  displayedColumns: any = [];
  keyColumns: any = []; // Columns with link
  datalistsource: MatTableDataSource<any>; // MatTableDataSource
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(
    private apifactory: ApiFactoryService,
    public i18n: I18nService,
    private router: Router,
    private shareData: ShareddataService,
    private globalService: GlobalsService,
    private http: HttpClient,
    private authservice: AuthenticationService
  ) {

    this.bffapi = this.apifactory.createBffApi();
    this.serverRoot = this.globalService.getBffapiroot();

    this.users = [];
    this.markets = [];
    this.companies = [];
    this.productTypes = [];

    this.showFilters = false;

    this.oldestDate = this.filterObject.fromDate;

    this.currentOrder = null;

    this.showSearch = false;
  }

  ngOnInit(): void {
    this.displayedColumns = ['nr', 'created', 'user_company', 'country_label', 'productTypeLabel', 'assetName', 'd_width', 'd_height', 'd_unit', 'status', 'actions'];
    this.keyColumns = ['id'];

    const query = this.bffapi.getRecentOrders('aos');
    query.subscribe((allresults: any) => {

        console.log(this.shareData.getMandantLabel());

        /**
         * Longines custom display of data table columns
         */
        // Adds the star and collection columns for Longines
        if (this.shareData.getMandantLabel() === 'longines') {
          allresults.results = allresults.results.map(r => {
            // Extract the star and collection values from the assetName
            if (r.assetName) {
              const regexResult = /.*--([a-zA-Z\d]+)_([a-zA-Z\d_-]+)--(.*)\..*/gm.exec(r.assetName);
              r.star = regexResult && regexResult[1] ? regexResult[1] : '';
              r.collection = regexResult && regexResult[2] ? regexResult[2] : '';
            } else {
              r.star = '';
              r.collection = '';
            }
            return r;
          });
          this.displayedColumns.splice(6, 0, 'star');
          this.displayedColumns.splice(7, 0, 'collection');
        }

        this.datalistsource = new MatTableDataSource(allresults.results);
        this.datalistsource.sort = this.sort;
        this.datalistsource.paginator = this.paginator;
        this.onDataSourceReady();
      },
      error => {
        if (error.status === 403) { // Session expired
          this.authservice.setLoggedin(false);
          this.router.navigate(['']);
        }
      });

  }

  onDataSourceReady() {
    this.datalistsource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'created':
          return new Date(item.created.date);
        default:
          return item[property];
      }
    };
    this.datalistsource.filterPredicate = this.filterPredicateHandler.bind(this);

    // Finds the oldest order
    const oldestCreated: Date = this.datalistsource.data.length > 0
      ? new Date(new Date(this.datalistsource.data[this.datalistsource.data.length - 1].created.date))
      : moment().subtract(3, 'months').toDate();

    // Sets the fromDate and creation date using the oldest order fetched
    this.filterObject.fromDate = this.oldestDate = oldestCreated;

    // Initializes filter options
    /**
     * Extra filters: Currently deactivated
     * this.initFilterOptions();
     */
  }

  applyFilter($event?: Event) {
    this.datalistsource.filter = JSON.stringify(this.filterObject);
  }

  getColumnLabel(fieldName: string) {
    switch (fieldName) {
      case 'user_company':
        return this.i18n.get('global_company_user_label');

      case 'country_label':
        return this.i18n.get('global_market_label');

      case 'nr':
        return this.i18n.get('orders_order_nr_label', 'orders');

      case 'created':
        return this.i18n.get('orders_order_date_label', 'orders');

      case 'productTypeLabel':
        return this.i18n.get('orders_order_product_label', 'orders');

      case 'd_width':
        return this.i18n.get('orders_order_width_label', 'orders');

      case 'd_height':
        return this.i18n.get('orders_order_height_label', 'orders');

      case 'd_unit':
        return this.i18n.get('orders_order_unit_label', 'orders');

      case 'assetName':
        return this.i18n.get('orders_order_asset_name_label', 'orders');

      case 'actions':
        return '';

      case 'status':
        return '';

      default:
        return fieldName;
    }
  }

  getFormattedValue(fieldName: string, value: any) {
    if (fieldName === 'created') {
      return moment(value.date).format('DD/MM/YYYY HH:mm');
    }
    return value;
  }

  initFilterOptions() {
    // Extracts all possible filter value from the datasource
    for (const record of this.datalistsource.data) {
      this.productTypes.push({
        id: record.productTypeId,
        label: record.productTypeLabel
      });
      this.companies.push({
        id: record.companyId,
        label: record.company_label
      });
      this.markets.push({
        id: record.countryId,
        label: record.country_label
      });
      this.users.push({
        id: record.userId,
        label: record.userFullName
      });
    }

    const purgeFilter = (array) => {
      const obj = {};
      for (let i = 0, len = array.length; i < len; i++) {
        obj[array[i].id] = array[i];
      }
      array = new Array();
      for (const key in obj) {
        array.push(obj[key]);
      }
      return array;
    };

    this.productTypes = purgeFilter(this.productTypes);
    this.companies = purgeFilter(this.companies);
    this.markets = purgeFilter(this.markets);
    this.users = purgeFilter(this.users);

    // Sorts alphabetically
    const sort = (a, b) => {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    };
    this.productTypes.sort(sort);
    this.companies.sort(sort);
    this.markets.sort(sort);
    this.users.sort(sort);
  }

  filterPredicateHandler(inputData, filter: string): boolean {

    const filterObject = JSON.parse(filter);

    // Global text filtering
    let textCriteria = true;
    if (filterObject?.filtervalue !== '') {
      const nrCriteria = this.containsLowercaseFilter(inputData.nr, filterObject.filtervalue);
      const userFullNameCriteria = this.containsLowercaseFilter(inputData.userFullName, filterObject.filtervalue);
      const companyLabelCriteria = this.containsLowercaseFilter(inputData.company_label, filterObject.filtervalue);
      const countryLabelCriteria = this.containsLowercaseFilter(inputData.country_label, filterObject.filtervalue);
      const productTypeLabelCriteria = this.containsLowercaseFilter(inputData.productTypeLabel, filterObject.filtervalue);
      const assetNameCriteria = this.containsLowercaseFilter(inputData.assetName, filterObject.filtervalue);

      textCriteria = nrCriteria || userFullNameCriteria
        || companyLabelCriteria || countryLabelCriteria || productTypeLabelCriteria
        || assetNameCriteria;
    }

    // Specific column filtering
    // const productTypeIdCriteria = filterObject.productTypeId === 0 || inputData.productTypeId === filterObject.productTypeId;
    // const marketIdCriteria = filterObject.marketId === 0 || inputData.countryId === filterObject.marketId;
    // const companyIdCriteria = filterObject.companyId === 0 || inputData.companyId === filterObject.companyId;
    // const userIdCriteria = filterObject.userId === 0 || inputData.userId === filterObject.userId;

    // Date range filtering
    // const dateRangeCriteria = new Date(filterObject.fromDate).getTime() <= new Date(inputData.created.date).getTime()
    //  && new Date(filterObject.untilDate).getTime() >= new Date(inputData.created.date).getTime();

    // const filteredIn = textCriteria && productTypeIdCriteria && marketIdCriteria && companyIdCriteria
    //  && userIdCriteria && dateRangeCriteria;

    const filteredIn = textCriteria;

    return filteredIn;
  }

  containsLowercaseFilter(data, filter: string) {
    data = String(data);
    const treatedfilter = filter.trim().toLowerCase();
    const treateddata = data.trim().toLowerCase();

    const searchresult = treateddata.search(treatedfilter);
    if (searchresult === -1) { // No match
      return false;
    } // if
    return true;
  }

  applyDateRange($event: Date) {
    if (!this.datalistsource) {
      return;
    }

    if (new Date(this.filterObject.fromDate).getTime() >= new Date(this.oldestDate).getTime()) {
      // Applies filter on current data
      this.applyFilter();
    } else {
      // TODO: Fetches missing data
      // ...

      // Sets oldest record fetch
      this.oldestDate = this.filterObject.fromDate;

      this.onDataSourceReady();

      // Applies filter over new data
      this.applyFilter();
    }
  }

  openDetails(order: AosOrderInterface) {
    this.currentOrder = order;
  }

  closeDetails() {
    this.currentOrder = null;
  }

  openSearch() {
    this.showSearch = true;
  }

  closeSearch() {
    this.showSearch = false;
  }

  renewOrder(order: AosOrderInterface) {
    // Redirect to the only aos prod tool of the mandant with autologin info

    const renewPath = this.globalService.getAosProdRenewPath(
      this.shareData.getCurrentlanguage(),
      this.shareData.getUserTools(), order);

    this.router.navigate(renewPath);
  }
}
